//To do:
// Add a function that converts a hexadecimal color to an RGBA color including the alpha value
// Add a function that converts an RGBA color to a hexadecimal color including the alpha value
// Add a function that converts a hexadecimal color to an RGB color including the alpha value
// Add a function that converts an RGB color to a hexadecimal color including the alpha value






export const adjustColorOpacity = (color: string, opacity = 1) => {

  opacity = Math.max(0, Math.min(1, opacity));

  if (color.startsWith("#")) {
    if (color.length === 7) {
      return `${color}${Math.round(opacity * 255).toString(16).padStart(2, '0')}`;
    } else if (color.length === 9) {
      return color;
    } else {
      throw new Error("Invalid HEX color format");
    }
  } else if (color.startsWith("rgb")) {
    const rgbMatch = color.match(/rgba?\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3})(?:,\s*(0|1|0?\.\d+))?\)/);

    if (rgbMatch) {
      const [, r, g, b, existingAlpha] = rgbMatch;
      if (existingAlpha !== undefined) {
        return color;
      } else {
        return `rgba(${r}, ${g}, ${b}, ${opacity})`;
      }
    } else {
      throw new Error("Invalid RGB/RGBA color format");
    }
  } else {
    throw new Error("Unsupported color format");
  }
}